/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useState, useEffect } from "react";

export const useDebounce = <T = string>(value: T, delay: number = 300): T => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
};
